@switch (navAction().type) {
  @case ('link') {
    @if (isExternalLink()) {
      <u-button
        type="link"
        [href]="getExternalHref()"
        [isExternalLink]="true"
        [ngClass]="styleClasses()"
        [attrTranslate]="navLink().labelKey || navLink().label"
        [onClick]="handleExternalRedirection"
        (pointerenter)="animateHoverReveal($event)"
        (pointermove)="moveHoverReveal($event)"
        (pointerleave)="resetHoverReveal($event)"
        (focusin)="animateHoverReveal($event)"
        (focusout)="resetHoverReveal($event)"
      >
        @if (navLink().icon) {
          <fa-icon [icon]="iconProp()" class="inherit" />
          <span class="nbsp">&nbsp;</span>
        }

        <ng-container *ngTemplateOutlet="spanTextTmpl"></ng-container>
      </u-button>
    } @else {
      <u-button
        type="link"
        [href]="href()"
        [isExternalLink]="false"
        [ngClass]="styleClasses()"
        [isActive]="isRouteActive()"
        [onClick]="handleRedirection"
        [attrTranslate]="navLink().labelKey"
        (pointerenter)="animateHoverReveal($event)"
        (pointermove)="moveHoverReveal($event)"
        (pointerleave)="resetHoverReveal($event)"
        (focusin)="animateHoverReveal($event)"
        (focusout)="resetHoverReveal($event)"
      >
        @if (navLink().icon) {
          <fa-icon [icon]="iconProp()" class="inherit" />
          <span class="nbsp">&nbsp;</span>
        }
        <ng-container *ngTemplateOutlet="spanTextTmpl"></ng-container>
      </u-button>
    }
  }
  @case ('command') {
    <u-button
      type="button"
      [ngClass]="styleClasses()"
      [onClick]="handleCommand"
      (pointerenter)="animateHoverReveal($event)"
      (pointermove)="moveHoverReveal($event)"
      (pointerleave)="resetHoverReveal($event)"
      (focusin)="animateHoverReveal($event)"
      (focusout)="resetHoverReveal($event)"
    >
      @if (navLink().icon) {
        <fa-icon [icon]="iconProp()" class="inherit" />
        <span class="nbsp">&nbsp;</span>
      }
      <ng-container *ngTemplateOutlet="spanTextTmpl"></ng-container>
    </u-button>
  }
  @case ('component') {
    <ng-container #componentPlace />
  }
}

<ng-template #spanTextTmpl>
  @if (navAction().loadingTranslation) {
    <ush-loading-indicator [style.height]="'100%'" [aligning]="'absolute-center'"></ush-loading-indicator>
  } @else {
    @if (navActionHoverRevealEnabled()) {
      <span class="movie-site_nav-action_hover-reveal" data-movie-site-nav-action-hover-reveal aria-hidden="true"></span>
    }
    <span class="link-text" [attr.data-translate]="navLink().labelKey">{{
      navLink().label || navAction().placeholder
    }}</span>
  }
</ng-template>
